export const REGISTERED_USER_API_CODE = 4702089;
export const VALIDATION_CODE_LENGTH = 6;
export const INVALID_VALIDATION_CODE_API_CODE = 4702086;
